import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tag-wrapper" }
const _hoisted_2 = ["pageTexts", "onClick"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FlightOption = _resolveComponent("FlightOption")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FlightOption, {
      flight: _ctx.selectedFlight,
      selectedFlightId: _ctx.selectedFlight.id,
      isSelectedFlight: true,
      id: 'selected',
      name: 'selected',
      pageTexts: _ctx.pageTexts,
      localeStrings: _ctx.localeStrings
    }, null, 8, ["flight", "selectedFlightId", "pageTexts", "localeStrings"]),
    (_ctx.selectedTags && _ctx.selectedTags.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.flightRecommendations.paging.totalResults) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepResultsWithFilterHeadline']), 1),
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTags, (selectedTag, index) => {
              return (_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "tag-btn",
                key: index,
                pageTexts: _ctx.pageTexts,
                onClick: ($event: any) => (_ctx.removeTagFilter(selectedTag))
              }, _toDisplayString(selectedTag.name), 9, _hoisted_2))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.flights && _ctx.flights.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_ctx.pageIndex === 1)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.flights.slice(0, 2), (flight, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createVNode(_component_FlightOption, {
                    flight: flight,
                    id: index.toString(),
                    selectedFlightId: _ctx.selectedFlight.id,
                    pageTexts: _ctx.pageTexts,
                    localeStrings: _ctx.localeStrings,
                    name: 'departureOptions'
                  }, null, 8, ["flight", "id", "selectedFlightId", "pageTexts", "localeStrings"])
                ]))
              }), 128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.flights, (flight, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createVNode(_component_FlightOption, {
                    flight: flight,
                    id: index.toString(),
                    selectedFlightId: _ctx.selectedFlight.id,
                    pageTexts: _ctx.pageTexts,
                    localeStrings: _ctx.localeStrings,
                    name: 'departureOptions'
                  }, null, 8, ["flight", "id", "selectedFlightId", "pageTexts", "localeStrings"])
                ]))
              }), 128))
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepNoResultsWithFilterHeadline']), 1),
          _createElementVNode("div", {
            class: "rte",
            innerHTML: _ctx.pageTexts['hotelPageFlightStepNoResultsWithFilterText']
          }, null, 8, _hoisted_5)
        ]))
  ], 64))
}